import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/Frontend.jsx");
